import { render } from "./CustomerDetailDocumentsTab.vue?vue&type=template&id=9df5cae8&scoped=true"
import script from "./CustomerDetailDocumentsTab.vue?vue&type=script&lang=js"
export * from "./CustomerDetailDocumentsTab.vue?vue&type=script&lang=js"

import "./CustomerDetailDocumentsTab.vue?vue&type=style&index=0&id=9df5cae8&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9df5cae8"]])

export default __exports__